export default __webpack_public_path__ + "assets/images/45c081755618fdc9f4594d8d4ce3668a.png";